import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Immediately trigger loader removal to prevent being stuck on the splash screen
const hideLoader = () => {
  const loader = document.getElementById('app-loader');
  if (loader) {
    loader.style.opacity = '0';
    setTimeout(() => {
      loader.style.display = 'none';
    }, 500);
  }
};

// We hide the loader as soon as the JS execution reaches this point
// and also hook into the window load as a fallback.
hideLoader();
window.addEventListener('load', hideLoader);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);